'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentInput = function (_React$Component) {
	_inherits(CommentInput, _React$Component);

	function CommentInput(props) {
		_classCallCheck(this, CommentInput);

		var _this = _possibleConstructorReturn(this, (CommentInput.__proto__ || Object.getPrototypeOf(CommentInput)).call(this, props));

		_this.state = {
			comment: ''
		};

		_this.handleCommentChange = _this._handleCommentChange.bind(_this);
		_this.handleSubmit = _this._handleSubmit.bind(_this);
		return _this;
	}

	_createClass(CommentInput, [{
		key: 'render',
		value: function render() {

			var placeholder = this.props.parent_id ? 'Reply to this note' : 'Write a note or comment';

			var imageStyle = CURRENT_USER.image ? { backgroundImage: 'url(' + CURRENT_USER.image + ')' } : {};

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("section comment-input", { show: this.props.show }) },
				_react2.default.createElement('div', { className: 'image', style: imageStyle }),
				_react2.default.createElement(
					'div',
					{ className: 'content' },
					_react2.default.createElement(
						'div',
						{ className: 'comment-input-group' },
						_react2.default.createElement('input', {
							type: 'text',
							placeholder: placeholder,
							value: this.state.comment,
							onChange: this.handleCommentChange
						}),
						_react2.default.createElement(
							'div',
							{
								className: 'comment-button',
								onClick: this.handleSubmit
							},
							'+'
						)
					)
				)
			);
		}
	}, {
		key: '_handleCommentChange',
		value: function _handleCommentChange(e) {
			this.setState({
				comment: e.target.value
			});
		}
	}, {
		key: '_handleSubmit',
		value: function _handleSubmit() {
			this.props.onSubmit({
				parent_id: this.props.parent_id,
				comment: this.state.comment
			});
			if (this.props.closeWindow) this.props.closeWindow();
			this.setState({
				comment: ''
			});
		}
	}]);

	return CommentInput;
}(_react2.default.Component);

exports.default = CommentInput;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/notes/CommentInput.js
// module id = 245
// module chunks = 0